let $tt = $("<div />").addClass("tooltip");
let $tt_message = $("<div />").addClass("tooltip__message");
let $body = $("body");

$tt.append($tt_message);
$body.append($tt.hide());

function position_tooltip(e) {
	$tt.css({
		left: e.clientX,
		top: e.clientY
	});
}

function set_message(message) {
	$tt_message.text(message);
}

function tooltip_on() {
	let message = $(this).data("area").title;
	set_message(message);
	$(document).on("mousemove", position_tooltip);
	$tt.show();
}

function tooltip_off() {
	$(document).off("mousemove");
	$tt.hide();
}

export function tooltip($target) {
	$target.on("mouseover", tooltip_on);
	$target.on("mouseleave", tooltip_off);
	$target.on("click", tooltip_off);
}

